import { watch } from "vue";
import type { Ref } from "vue";
import type { Emits } from "@/typings/emits";
import useDefaultValue from "@/composables/useDefaultValue";
/**
 * @function useModifiableProp - take a prop and return a ref value that depends on itself and the prop
 * @param {Ref<PropType>}prop - the component prop
 * @param {PropType} defaultValue - default value in case the prop is not defined
 * @param {Emits<PropType,EmitName>} emits - emit function with a defined call signature
 * @param {EmitName} emitName - name of the emit in the emits function, call signature must exist to call the function
 * @returns
 */
export default function useModifiableProp<PropType, EmitName>(
  prop: Ref<PropType> | undefined,
  defaultValue: PropType,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emits: Emits<PropType, EmitName>,
  emitName: EmitName
): Ref<PropType> {
  const value = useDefaultValue(prop, defaultValue);

  //if the value changes emit the event to change it outside
  watch(value, (newValue) => emits(emitName as EmitName, newValue as PropType));

  return value as Ref<PropType>;
}
